import { render, staticRenderFns } from "./MainPageNewsSection.vue?vue&type=template&id=42621510&scoped=true"
import script from "./MainPageNewsSection.vue?vue&type=script&lang=js"
export * from "./MainPageNewsSection.vue?vue&type=script&lang=js"
import style0 from "./MainPageNewsSection.vue?vue&type=style&index=0&id=42621510&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42621510",
  null
  
)

export default component.exports